// React Imports
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Provider } from 'react-redux';
import { Router } from 'react-router';

// My Imports
import routes from '../routes';

class Root extends Component {
    render() {
        const { store, history } = this.props;
        return <Provider store={store}>
            <div>
                <Router history={history} routes={routes}/>
            </div>
        </Provider>;
    }
}

Root.displayName = 'Root';

Root.propTypes = {
    history: PropTypes.object.isRequired,
    store: PropTypes.object.isRequired
};

export default Root;



/** WEBPACK FOOTER **
 ** ./src/containers/Root.prod.js
 **/